<template>
   <div class="my-5">
       <h3 class="text-info my-4">Dog's Silhouette<br><small class="text-muted border-top">Choose a Dog's Silhouette</small></h3>
       <div class="sihlouette-container rounded">
           <div class="row">
               <div class="col-md col-sm-4 col-6 p-3" v-for="dog in Dogs" :key="dog.value">
                   <img @click="selectThis(dog.img_name)" 
                        class="img-fluid animal-pic" 
                        :src="'/static/img/dogs/' + dog.img_name" alt="Dog's Silhouette">
                <transition name="fade">
                   <img v-show="selectedDoggy.includes(dog.value)" 
                        class="selected-animal-silhouette img-fluid animal-pic" 
                        @click="removeThis(dog.value)"
                        :src="'/static/img/dogs/' + dog.img_name_selected" 
                        alt="Selected Dog">
                </transition>
               </div>
           </div>
       </div>
   </div>
       
</template>
<script>
    import Data from '@/data/data'
    export default {
        name: 'Dogs',
       data() {
           return {
               Dogs: Data.dogs,
               selectedDoggy: ''
           }
       },
       methods: {
           selectThis(dog) {
               this.selectedDoggy = dog;
               this.$emit('getThisDog', dog)
           },
           removeThis(dog){
                this.selectedDoggy = ''
                this.$emit('removeThisDog', dog)
           }
       }
    }
</script>





// WEBPACK FOOTER //
// src/components/JQueryPluggins/Dogs.vue